var map = {
	"./feed/app.config.js": 1208,
	"./help-centre/app.config.js": 9887,
	"./home/app.config.js": 2297,
	"./login/app.config.js": 1235,
	"./mdc/app.config.js": 8422,
	"./myaccount/app.config.js": 903,
	"./players/app.config.js": 6297,
	"./search/app.config.js": 4600,
	"./store/app.config.js": 8359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5595;